export default {
    addressSearch: (searchQuery, numberOfHits) => {
        const dataLayerData = {
            event: 'addressSearch',
            addressSearchQuery: searchQuery,
            addressSearchResults: numberOfHits,
        };

        window.dataLayer.push(dataLayerData);
    },
    addressChosen: (searchQuery, addressSource) => {
        window.dataLayer.push({
            event: 'addressChosen',
            addressSearchQuery: searchQuery,
            addressSource: addressSource,
        });
    },
    addressApartmentList: (searchQuery, searchResults) => {
        window.dataLayer.push({
            event: 'addressApartmentList',
            addressSearchQuery: searchQuery,
            addressSearchResults: searchResults,
        });
    },
    addressHasCustomer: (chosenAddress) => {
        window.dataLayer.push({
            event: 'addressHasCustomer',
            addressSearchQuery: chosenAddress,
        });
    },
    formSubmission: (formName) => {
        window.dataLayer.push({
            event: 'formSubmission',
            formName: formName,
        });
    },
    loggedIn: (onOpenNetwork, currentProducts, possibleProducts) => {
        window.dataLayer.push({
            event: 'loggedIn',
            userOnOpenNetwork: onOpenNetwork,
            userCurrentProducts: currentProducts,
            userPossibleProducts: possibleProducts,
        });
    },
    productImpressions: (products, list) => {
        let position = 1;

        products = products.map(product => {
            product.quantity = 1; //Hardcoded, will always be 1 for now.
            product.position = position++;
            product.list = list;

            return product;
        });

        window.dataLayer.push({
            event: 'productImpressions',
            ecommerce: {
                impressions: products,
            },
        });
    },
    purchase: (gtmOrderData) => {
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: gtmOrderData.orderId,
                        md5: gtmOrderData.md5,
                        revenue: gtmOrderData.totalPriceExclVat,
                        tax: gtmOrderData.totalVat,
                    },
                    products: gtmOrderData.products,
                },
            },
        });
    },
    checkout: (products, step) => {
        products = products.map(product => {
            product.quantity = 1; //Hardcoded, will always be 1 for now.

            return product;
        });

        window.dataLayer.push({
            'event': 'checkout',
            'ecommerce': {
                'checkout': {
                    'actionField': { 'step': step },
                    'products': products,
                },
            },
        });
    },
    addToCart: (products, list) => {
        const defaultListLocation = 'Tjänster';

        products = products.map(product => {
            product.quantity = 1; //Hardcoded, will always be 1 for now.

            return product;
        });

        window.dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                add: {
                    actionField: { list: list || defaultListLocation },
                    products: products,
                },
            },
        });
    },
    productDetailView: (products) => {
        window.dataLayer.push({
            event: 'productDetailView',
            ecommerce: {
                detail: {
                    products: products,
                },
            },
        });
    },
    cookiePolicyApproved: () => {
        window.dataLayer.push({
            event: 'cookiePolicyApproved',
        });
    },
};
